import React, { useState } from 'react';

import { Box, Stack, TextField, Popover } from '@mui/material';

import { HoverOverlayDiv } from './HoverOverlay';
import { Users } from 'react-feather';

import { CapacityFilterPicker } from '../pickers/CapacityFilterPicker';

import type { CapacityValues } from '../../../types/components/filter_bar_types';
import { getCapacityText } from '../utils';
export interface CapacityFilterSelectorProps {
  initialValues: CapacityValues;
  onSubmit: (values: CapacityValues) => void;
  onCancel: () => void;
}

export const CapacityFilterSelector = ({
  initialValues,
  onSubmit,
  onCancel,
}: CapacityFilterSelectorProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const valueText = getCapacityText(initialValues);
  const handleSubmit = (values: CapacityValues) => {
    onSubmit(values);
    handleClose();
  };
  const handleClear = () => {
    onCancel();
    handleClose();
  };
  return (
    <Stack
      direction="row"
      alignItems="center"
      marginLeft="8px"
      position="relative"
      width="100%"
      sx={{
        cursor: 'pointer',
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '&:hover .HoverOverlay': {
          opacity: '0.2',
        },
        '&:focus-within .HoverOverlay': {
          opacity: '0.2',
        },
      }}
    >
      <Users style={{ marginBottom: '16px', marginLeft: '16px' }} />
      <TextField
        size="small"
        label="Guests"
        value={valueText}
        onClick={handleClick}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            handleClick(event);
          }
        }}
        fullWidth
        InputProps={{
          readOnly: true,
        }}
      />
      <HoverOverlayDiv className="HoverOverlay" style={{ width: '101%' }} />
      <Popover
        id="event-capacity-selector-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box padding="24px">
          <CapacityFilterPicker
            initialValues={initialValues}
            onSubmit={handleSubmit}
            onCancel={handleClear}
          />
        </Box>
      </Popover>
    </Stack>
  );
};
